export default {"src":"/_next/static/media/menuButton.40dee3d4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};